export default {
  years: {
    billingCycleLabel: 'annual',
  },
  months: {
    billingCycleLabel: 'monthly',
  },
  days: {
    billingCycleLabel: 'per 24 hours',
  },
}
